<script>
export default {
  name: 'LayoutDefault',
  data () {
    return {
    }
  }
}
</script>

<template lang="pug" src="./template.pug"></template>
<style lang="scss" src="./style.scss"></style>
